<template>
    <div class="">
      <Card class="">
        <template #title> Diyet Tanımları </template>
        <template #content>
          <div class="mt-1 mb-2 mr-3">
            <Button icon="pi pi-plus " size="small" label="Yeni" @click="_YeniDiyet()" />
          </div>
          <DataTable v-if="DataTable_render" :columns="columns" :data="DiyetListesi" v-on:set-child-data="getDataChild"
            :editbutton="true" />
        </template>
      </Card>
    </div>
  </template>
  
  <script>
  import DataTable from "../../DataTable/BasicDataTable.vue";
  import GlobalServis from "../../../../../services/GlobalServis";
  import { required, helpers } from "@vuelidate/validators";
  import { useVuelidate } from "@vuelidate/core";
  
  export default {
    setup: () => ({ v$: useVuelidate() }),
    data() {
      return {
        DataTable_render: true,
        DiyetListesi: [],
        columns: [
          { field: "DiyetTanimAd", header: "Diyet" },
          { field: "Gun",  header: "Gün" },
          { field: "DiyetTanimTarih",  header: "Tarih" },
        ],
  
        DiyetAd: null,
        DiyetAciklama: null,
        DiyetTanim_rowid: null,
      };
    },
    methods: {
      getDataChild(getdata_child) {
        this.DiyetTanim_rowid = getdata_child.data.DiyetTanim_rowid;      
        this.$router.push({ path: "/Diyetisyen/DuzenleDiyetTanim", query: { DiyetNo: this.DiyetTanim_rowid } });
      },
      _YeniDiyet() {
        this.$router.push({ path: "/Diyetisyen/YeniDiyetTanim" });
      },
      InitServis() {
        GlobalServis.GlobalServis("GET", "GetDiyetTanimTablosu", "").then((res) => {
          if (res.status == 200) {
            this.DiyetListesi = res.data;
          } else if (res.status == 400) {
            this.$toast.add({
              severity: "error",
              summary: "Hata",
              detail: "Önemli bir hata meydana geldi",
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Hata",
              detail: "Bilinmeyen bir hata meydana geldi",
              life: 3000,
            });
          }
        });
      },
    },
    mounted() {
      this.InitServis();
    },
    components: {
      DataTable,
    },
    validations() {
      return {
        DiyetAd: {
          required: helpers.withMessage("Bu alan boş bırakılamaz", required),
        },
        DiyetAciklama: {
          required: helpers.withMessage("Bu alan boş bırakılamaz", required),
        },
      };
    },
  };
  </script>